import { Routes, Route, Navigate } from 'react-router-dom';

import { AccountProfilePage } from '../features/accounts/AccountProfilePage.js';
import { AccountsPage } from '../features/accounts/AccountsPage.js';
import { AISettingsPage } from '../features/ai/AISettingsPage.js';
import { LoginPage } from '../features/auth/LoginPage.js';
import { SignupPage } from '../features/auth/SignupPage.js';
import { BrandsPage } from '../features/brands/BrandsPage.js';
import { CashbackCustomersPage } from '../features/cashback/CashbackCustomersPage.js';
import { CashbackLedgerPage } from '../features/cashback/CashbackLedgerPage.js';
import { CashbackSettingsPage } from '../features/cashback/CashbackSettingsPage.js';
import { CategoriesPage } from '../features/categories/CategoriesPage.js';
import { CmsNavigationPage } from '../features/cms/CmsNavigationPage.js';
import { CmsOrderDetailPage } from '../features/cms/CmsOrderDetailPage.js';
import { CmsOrdersPage } from '../features/cms/CmsOrdersPage.js';
import { CmsPagesPage } from '../features/cms/CmsPagesPage.js';
import { CmsProductsPage } from '../features/cms/CmsProductsPage.js';
import { CmsReviewsPage } from '../features/cms/CmsReviewsPage.js';
import { CmsSettingsPage } from '../features/cms/CmsSettingsPage.js';
import { CmsSlidesPage } from '../features/cms/CmsSlidesPage.js';
import { CmsStoreCategoriesPage } from '../features/cms/CmsStoreCategoriesPage.js';
import { CombosPage } from '../features/combos/CombosPage.js';
import { CouponFormPage } from '../features/coupons/CouponFormPage.js';
import { CouponRedemptionsPage } from '../features/coupons/CouponRedemptionsPage.js';
import { CouponsPage } from '../features/coupons/CouponsPage.js';
import { ActivitiesPage } from '../features/crm/ActivitiesPage.js';
import { ContactsPage } from '../features/crm/ContactsPage.js';
import { CrmAccountsPage } from '../features/crm/CrmAccountsPage.js';
import { LeadsPage } from '../features/crm/LeadsPage.js';
import { OpportunitiesPage } from '../features/crm/OpportunitiesPage.js';
import { DashboardPage } from '../features/dashboard/DashboardPage.js';
import { ReturnDetailPage } from '../features/documents/ReturnDetailPage.js';
import { SalesDocumentsPage } from '../features/documents/SalesDocumentsPage.js';
import { SalesOrderPrintPage } from '../features/documents/SalesOrderPrintPage.js';
import { PosSalePrintPage } from '../features/documents/PosSalePrintPage.js';
import { ExpensesPage } from '../features/expenses/ExpensesPage.js';
import { ExpensesReportPage } from '../features/expenses/ExpensesReportPage.js';
import { ReturnsPage, ReturnNewPage } from '../features/documents/ReturnsPage.js';
import { FileManagerPage } from '../features/files/FileManagerPage.js';
import { JournalEntryFormPage } from '../features/gl/JournalEntryFormPage.js';
import { JournalsPage } from '../features/gl/JournalsPage.js';
import { TransactionsPage } from '../features/gl/TransactionsPage.js';
import { RolesPage } from '../features/settings/RolesPage.js';
import { VouchersPage } from '../features/vouchers/VouchersPage.js';
import { ExchangeRatesPage } from '../features/currencies/ExchangeRatesPage.js';
import { TreasuryTransfersPage } from '../features/treasury/TreasuryTransfersPage.js';
import { DeliveryBoardPage } from '../features/delivery/DeliveryBoardPage.js';
import { DeliveryCitiesPage } from '../features/delivery/DeliveryCitiesPage.js';
import { StoriesPage } from '../features/stories/StoriesPage.js';
import { HighlightsPage } from '../features/stories/HighlightsPage.js';
import { DeliveryDetailPage } from '../features/delivery/DeliveryDetailPage.js';
import { MyDeliveriesPage } from '../features/delivery/MyDeliveriesPage.js';
import { DiscountFormPage } from '../features/discounts/DiscountFormPage.js';
import { DiscountsPage } from '../features/discounts/DiscountsPage.js';
import { BillPrintPage } from '../features/documents/BillPrintPage.js';
import { DocumentDetailPage } from '../features/documents/DocumentDetailPage.js';
import { DocumentFormPage } from '../features/documents/DocumentFormPage.js';
import { DocumentListPage } from '../features/documents/DocumentListPage.js';
import { InvoicePrintPage } from '../features/documents/InvoicePrintPage.js';
import { PaymentVoucherPrintPage } from '../features/documents/PaymentVoucherPrintPage.js';
import { QuotationPrintPage } from '../features/documents/QuotationPrintPage.js';
import { JournalVoucherPrintPage } from '../features/gl/JournalVoucherPrintPage.js';
import { FibSettingsPage } from '../features/fib/FibSettingsPage.js';
import { PeriodsPage } from '../features/gl/PeriodsPage.js';
import { TrialBalancePage } from '../features/gl/TrialBalancePage.js';
import { AttendanceKioskPage } from '../features/hr/attendance/AttendanceKioskPage.js';
import { AttendancePage } from '../features/hr/attendance/AttendancePage.js';
import { EmployeesPage } from '../features/hr/EmployeesPage.js';
import { LeaveRequestsPage } from '../features/hr/LeaveRequestsPage.js';
import { OrganizationPage } from '../features/hr/OrganizationPage.js';
import { PayrollRunsPage } from '../features/hr/PayrollRunsPage.js';
import { ImageSettingsPage } from '../features/imagegen/ImageSettingsPage.js';
import { ImageStudioPage } from '../features/imagegen/ImageStudioPage.js';
import { InstallmentPlansPage } from '../features/installments/InstallmentPlansPage.js';
import { InstallmentReportsPage } from '../features/installments/InstallmentReportsPage.js';
import { BatchesPage } from '../features/inventory/BatchesPage.js';
import { LabelsPage } from '../features/inventory/LabelsPage.js';
import { StockImportPage } from '../features/inventory/StockImportPage.js';
import { StockMovementsPage } from '../features/inventory/StockMovementsPage.js';
import { StockPage } from '../features/inventory/StockPage.js';
import { StocktakeDetailPage } from '../features/inventory/StocktakeDetailPage.js';
import { StocktakesPage } from '../features/inventory/StocktakesPage.js';
import { StockTransferDetailPage } from '../features/inventory/StockTransferDetailPage.js';
import { StockTransferFormPage } from '../features/inventory/StockTransferFormPage.js';
import { StockTransferPrintPage } from '../features/inventory/StockTransferPrintPage.js';
import { StockTransfersPage } from '../features/inventory/StockTransfersPage.js';
import { BomsPage } from '../features/manufacturing/BomsPage.js';
import { ProductionOrderDetailPage } from '../features/manufacturing/ProductionOrderDetailPage.js';
import { ProductionOrderFormPage } from '../features/manufacturing/ProductionOrderFormPage.js';
import { ProductionOrdersPage } from '../features/manufacturing/ProductionOrdersPage.js';
import { UnitsPage } from '../features/inventory/UnitsPage.js';
import { WarehousesPage } from '../features/inventory/WarehousesPage.js';
import { ItemDetailPage } from '../features/items/ItemDetailPage.js';
import { ItemFormPage } from '../features/items/ItemFormPage.js';
import { ItemsPage } from '../features/items/ItemsPage.js';
import { FieldWorkspacePage } from '../features/mandob/FieldWorkspacePage.js';
import { MandobProfilePage } from '../features/mandob/MandobProfilePage.js';
import { MandobsPage } from '../features/mandob/MandobsPage.js';
import { SendNotificationPage } from '../features/notifications/SendNotificationPage.js';
import { OtpSettingsPage } from '../features/otp/OtpSettingsPage.js';
import { PartiesPage } from '../features/parties/PartiesPage.js';
import { CustomerStatementPrintPage } from '../features/parties/CustomerStatementPrintPage.js';
import { PartyDetailPage } from '../features/parties/PartyDetailPage.js';
import { PlatformAdminsPage } from '../features/platform/PlatformAdminsPage.js';
import { PlatformAuditPage } from '../features/platform/PlatformAuditPage.js';
import { PlatformChangePasswordPage } from '../features/platform/PlatformChangePasswordPage.js';
import { PlatformCurrenciesPage } from '../features/platform/PlatformCurrenciesPage.js';
import { PlatformLoginPage } from '../features/platform/PlatformLoginPage.js';
import { PlatformOtpClientDetailPage } from '../features/platform/PlatformOtpClientDetailPage.js';
import { PlatformOtpDocsPage } from '../features/platform/PlatformOtpDocsPage.js';
import { PlatformOtpPaymentClaimsPage } from '../features/platform/PlatformOtpPaymentClaimsPage.js';
import { PlatformOtpServicePage } from '../features/platform/PlatformOtpServicePage.js';
import { PlatformPaymentsPage } from '../features/platform/PlatformPaymentsPage.js';
import { PlatformStoragePage } from '../features/platform/PlatformStoragePage.js';
import { PlatformTenantCreatePage } from '../features/platform/PlatformTenantCreatePage.js';
import { PlatformTenantDetailPage } from '../features/platform/PlatformTenantDetailPage.js';
import { PlatformTenantsPage } from '../features/platform/PlatformTenantsPage.js';
import { PlatformTerminalPage } from '../features/platform/PlatformTerminalPage.js';
import { PlatformWhatsAppPage } from '../features/platform/PlatformWhatsAppPage.js';
import { PortalCashbackPage } from '../features/portal/PortalCashbackPage.js';
import { PortalDashboardPage } from '../features/portal/PortalDashboardPage.js';
import { PortalInvoiceDetailPage } from '../features/portal/PortalInvoiceDetailPage.js';
import { PortalLoginPage } from '../features/portal/PortalLoginPage.js';
import { PortalNotificationsPage } from '../features/portal/PortalNotificationsPage.js';
import { PortalOrderDetailPage } from '../features/portal/PortalOrderDetailPage.js';
import { PortalOrdersPage } from '../features/portal/PortalOrdersPage.js';
import { PortalPaymentDetailPage } from '../features/portal/PortalPaymentDetailPage.js';
import { PortalProfilePage } from '../features/portal/PortalProfilePage.js';
import { PortalStatementPage } from '../features/portal/PortalStatementPage.js';
import { CustomerDisplayPage } from '../features/pos/CustomerDisplayPage.js';
import { PosRegisterPage } from '../features/pos/PosRegisterPage.js';
import { PosSalesPage } from '../features/pos/PosSalesPage.js';
import { PosTerminalsPage } from '../features/pos/PosTerminalsPage.js';
import { TerminalShiftsPage } from '../features/pos/TerminalShiftsPage.js';
import { CustomerRequestsPage } from '../features/pricing/CustomerRequestsPage.js';
import { PriceListsPage } from '../features/pricing/PriceListsPage.js';
import { PublicDocumentPage } from '../features/public/PublicDocumentPage.js';
import { PublicInvoicePage } from '../features/public/PublicInvoicePage.js';
import { PublicOrderPage } from '../features/public/PublicOrderPage.js';
import { AgingPage } from '../features/reports/AgingPage.js';
import { ProfitReportPage } from '../features/reports/ProfitReportPage.js';
import { BalanceSheetPage } from '../features/reports/BalanceSheetPage.js';
import { CashbackReportPage } from '../features/reports/CashbackReportPage.js';
import { PnLPage } from '../features/reports/PnLPage.js';
import { StatisticsPage } from '../features/reports/StatisticsPage.js';
import { StockReportPage } from '../features/reports/StockReportPage.js';
import { AiReportsPage } from '../features/ai-reports/AiReportsPage.js';
import { AiReportViewPage } from '../features/ai-reports/AiReportViewPage.js';
import { AuditLogPage } from '../features/settings/AuditLogPage.js';
import { CurrenciesPage } from '../features/settings/CurrenciesPage.js';
import { CustomFieldsPage } from '../features/settings/CustomFieldsPage.js';
import { DownloadsPage } from '../features/settings/DownloadsPage.js';
import { DriverProfilePage } from '../features/settings/DriverProfilePage.js';
import { InventorySettingsPage } from '../features/settings/InventorySettingsPage.js';
import { LanguagesPage } from '../features/settings/LanguagesPage.js';
import { ModulesPage } from '../features/settings/ModulesPage.js';
import { NumberingPage } from '../features/settings/NumberingPage.js';
import { PrintingSettingsPage } from '../features/settings/PrintingSettingsPage.js';
import { ProfilePage } from '../features/settings/ProfilePage.js';
import { PushNotificationsPage } from '../features/settings/PushNotificationsPage.js';
import { TelegramSettingsPage } from '../features/settings/TelegramSettingsPage.js';
import { TenantPage } from '../features/settings/TenantPage.js';
import { UsersPage } from '../features/settings/UsersPage.js';
import { WhatsAppSettingsPage } from '../features/settings/WhatsAppSettingsPage.js';
import { StorefrontBrandPage } from '../features/storefront/StorefrontBrandPage.js';
import { StorefrontBrandsPage } from '../features/storefront/StorefrontBrandsPage.js';
import { StorefrontCartPage } from '../features/storefront/StorefrontCartPage.js';
import { StorefrontCatalogPage } from '../features/storefront/StorefrontCatalogPage.js';
import { StorefrontCategoriesPage } from '../features/storefront/StorefrontCategoriesPage.js';
import { StorefrontCategoryPage } from '../features/storefront/StorefrontCategoryPage.js';
import { StorefrontCheckoutPage } from '../features/storefront/StorefrontCheckoutPage.js';
import { StorefrontHomePage } from '../features/storefront/StorefrontHomePage.js';
import { StorefrontLoginPage } from '../features/storefront/StorefrontLoginPage.js';
import { StorefrontNotFoundPage } from '../features/storefront/StorefrontNotFoundPage.js';
import { StorefrontOrderPage } from '../features/storefront/StorefrontOrderPage.js';
import { StorefrontPage } from '../features/storefront/StorefrontPage.js';
import { StorefrontProductPage } from '../features/storefront/StorefrontProductPage.js';
import { StorefrontWishlistPage } from '../features/storefront/StorefrontWishlistPage.js';

import { AppLayout } from './AppLayout.js';
import { AuthLayout } from './AuthLayout.js';
import { RequireCustomerAuth } from './customerGuards.js';
import { CustomerPortalLayout } from './CustomerPortalLayout.js';
import { RequireAuth, RequireModule, RequirePermission } from './guards.js';
import { RequirePlatformAuth } from './platformGuards.js';
import { PlatformLayout } from './PlatformLayout.js';
import { StorefrontLayout } from './StorefrontLayout.js';

export function AppRouter(): JSX.Element {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <AuthLayout>
            <LoginPage />
          </AuthLayout>
        }
      />
      <Route
        path="/signup"
        element={
          <AuthLayout>
            <SignupPage />
          </AuthLayout>
        }
      />

      <Route
        path="/"
        element={
          <RequireAuth>
            <AppLayout>
              <Navigate to="/dashboard" replace />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/dashboard"
        element={
          <RequireAuth>
            <AppLayout>
              <DashboardPage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/files"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['attachments.read']}>
                <FileManagerPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/settings/profile"
        element={
          <RequireAuth>
            <AppLayout>
              <ProfilePage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/settings/tenant"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['tenants.read']}>
                <TenantPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/settings/telegram"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['telegram.manage']}>
                <TelegramSettingsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/settings/push"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['push.manage']}>
                <PushNotificationsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/settings/whatsapp"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['whatsapp.manage']}>
                <WhatsAppSettingsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/notifications/send"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['push.manage']}>
                <SendNotificationPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/settings/users"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['users.read']}>
                <UsersPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      {/* Gated on roles.WRITE, not roles.read: `member` holds roles.read and
          permissions.read, and this page is a map of the tenant's whole
          permission architecture — not something every staffer should browse. */}
      <Route
        path="/settings/roles"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['roles.write']}>
                <RolesPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      {/* Persons → Drivers: the same users list, filtered to the people who can be
          assigned deliveries (a "driver" is a user whose role grants delivery.deliver). */}
      <Route
        path="/persons/drivers"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['users.read']}>
                <UsersPage
                  onlyPermission="delivery.deliver"
                  titleKey="drivers.title"
                  descriptionKey="drivers.description"
                  emptyKey="drivers.empty"
                  addKey="drivers.add"
                  fallbackRole={{ code: 'driver', name: 'Driver' }}
                  rowLinkBase="/persons/drivers"
                />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      {/* Per-driver profile: identity + delivery history + proof-of-delivery
          photos, aggregated read-only from data the delivery board already has. */}
      <Route
        path="/persons/drivers/:id"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['users.read']}>
                <DriverProfilePage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/settings/ai"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['ai.admin']}>
                <AISettingsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/imagegen"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['imagegen.use']}>
                <ImageStudioPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/settings/imagegen"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['imagegen.admin']}>
                <ImageSettingsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/settings/fib"
        element={
          <RequireAuth>
            <AppLayout>
              <RequireModule module="fib">
                <RequirePermission any={['settings.write']}>
                  <FibSettingsPage />
                </RequirePermission>
              </RequireModule>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/settings/otp"
        element={
          <RequireAuth>
            <AppLayout>
              <RequireModule module="otp">
                <RequirePermission any={['settings.write']}>
                  <OtpSettingsPage />
                </RequirePermission>
              </RequireModule>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/settings/numbering"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['settings.write']}>
                <NumberingPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/settings/inventory"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['settings.write']}>
                <InventorySettingsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/settings/printing"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['settings.write']}>
                <PrintingSettingsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/settings/custom-fields"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['items.read']}>
                <CustomFieldsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/settings/modules"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['settings.write']}>
                <ModulesPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/settings/currencies"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['settings.write']}>
                <CurrenciesPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/settings/languages"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['settings.write']}>
                <LanguagesPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/settings/downloads"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['settings.read']}>
                <DownloadsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/settings/audit-log"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['audit_logs.read']}>
                <AuditLogPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/accounting/accounts"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['accounts.read']}>
                <AccountsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/accounting/accounts/:id"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['accounts.read']}>
                <AccountProfilePage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/inventory/items"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['items.read']}>
                <ItemsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/inventory/labels"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['items.read']}>
                <LabelsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/inventory/items/new"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['items.write']}>
                <ItemFormPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/inventory/items/:id/edit"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['items.write']}>
                <ItemFormPage edit />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/inventory/items/:id"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['items.read']}>
                <ItemDetailPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/coupons"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['coupons.read']}>
                <CouponsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/coupons/redemptions"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['coupons.read']}>
                <CouponRedemptionsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/coupons/new"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['coupons.write']}>
                <CouponFormPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/coupons/:id/edit"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['coupons.write']}>
                <CouponFormPage edit />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/cashback"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['cashback.read']}>
                <CashbackSettingsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/mandob"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['mandob.manage']}>
                <MandobsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      {/* Field-rep orders, split out of /sales/orders. Same component, same detail
          page and same actions — only the server-side origin filter differs, so the
          two views can never drift apart. Declared before /mandob/:id purely for
          reading order; the router ranks the static segment higher either way. */}
      <Route
        path="/mandob/orders"
        element={
          <RequireAuth>
            <AppLayout>
              <RequireModule module="mandob">
                <RequirePermission any={['sales_orders.read']}>
                  <DocumentListPage
                    ns="documents:salesOrders"
                    endpoint="/sales-orders"
                    titleKey="nav.mandobOrders"
                    descriptionKey="mandobOrders.description"
                    listParams={{ origin: 'field' }}
                    showSalesRep
                    statusTone={{ draft: 'neutral', submitted: 'info', fulfilled: 'success', cancelled: 'danger' }}
                    detailPath="/sales/orders"
                    editable
                    printPath="/sales/orders"
                    writePermission="sales_orders.write"
                  />
                </RequirePermission>
              </RequireModule>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/mandob/:id"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['mandob.manage']}>
                <MandobProfilePage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/field"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['mandob.read']}>
                <FieldWorkspacePage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/cashback/customers"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['cashback.read']}>
                <CashbackCustomersPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/cashback/ledger"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['cashback.read']}>
                <CashbackLedgerPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/cms"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['cms.read']}>
                <CmsSettingsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/cms/pages"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['cms.read']}>
                <CmsPagesPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/cms/navigation"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['cms.read']}>
                <CmsNavigationPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/cms/slides"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['cms.read']}>
                <CmsSlidesPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/cms/reviews"
        element={
          <RequireAuth>
            <AppLayout>
              <RequireModule module="reviews">
                <RequirePermission any={['cms.read']}>
                  <CmsReviewsPage />
                </RequirePermission>
              </RequireModule>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/cms/products"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['cms.read']}>
                <CmsProductsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/cms/orders"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['cms.read']}>
                <CmsOrdersPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/cms/store-categories"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['cms.read']}>
                <CmsStoreCategoriesPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/cms/orders/:id"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['cms.read']}>
                <CmsOrderDetailPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      {/* An online order edited WITHOUT leaving the shop's own order desk: the
          ordinary sales-order form, pointed back at /cms/orders so Save and
          Cancel return to the order the operator came from. Gated on
          sales_orders.write — the form writes a sales order, whatever page it
          is embedded in. */}
      <Route
        path="/cms/orders/:id/edit"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['sales_orders.write']}>
              <DocumentFormPage ns="documents:salesOrders" endpoint="/sales-orders" partySide="customer" hasDueDate={false} listPath="/cms/orders" edit />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/sales/parties"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['parties.read']}>
                <PartiesPage side="customer" />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/purchasing/suppliers"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['parties.read']}>
                <PartiesPage side="vendor" />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/purchasing/suppliers/:id"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['parties.read']}>
                <PartyDetailPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/sales/price-lists"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['items.read']}>
                <PriceListsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/sales/discounts"
        element={
          <RequireAuth>
            <AppLayout>
              <RequireModule module="discounts">
                <RequirePermission any={['discounts.read']}>
                  <DiscountsPage />
                </RequirePermission>
              </RequireModule>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/sales/discounts/new"
        element={
          <RequireAuth>
            <AppLayout>
              <RequireModule module="discounts">
                <RequirePermission any={['discounts.write']}>
                  <DiscountFormPage />
                </RequirePermission>
              </RequireModule>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/sales/discounts/:id/edit"
        element={
          <RequireAuth>
            <AppLayout>
              <RequireModule module="discounts">
                <RequirePermission any={['discounts.write']}>
                  <DiscountFormPage edit />
                </RequirePermission>
              </RequireModule>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/sales/customer-requests"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['parties.read']}>
                <CustomerRequestsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/sales/parties/:id"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['parties.read']}>
                <PartyDetailPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/sales/parties/:id/statement/print"
        element={
          <RequireAuth>
            <RequirePermission any={['parties.read']}>
              <CustomerStatementPrintPage />
            </RequirePermission>
          </RequireAuth>
        }
      />
      <Route
        path="/inventory/categories"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['items.read']}>
                <CategoriesPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/inventory/brands"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['items.read']}>
                <BrandsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/inventory/units"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['items.read']}>
                <UnitsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/inventory/warehouses"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['warehouses.read']}>
                <WarehousesPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/inventory/stock"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['stock.read']}>
                <StockPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/inventory/stock/import"
        element={
          <RequireAuth>
            <AppLayout>
              {/* Writes products AND moves stock; the API demands both
                  items.write and stock.adjust, and the Import button on the
                  stock page only appears when the user holds both. */}
              <RequirePermission any={['items.write']}>
                <StockImportPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      {/* Transfers are NOT module-gated — the API mounts them for every tenant,
          so gating the page would hide a route that answers 200. */}
      <Route
        path="/inventory/transfers"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['stock.transfer.read']}>
              <StockTransfersPage />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/inventory/transfers/new"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['stock.transfer.write']}>
              <StockTransferFormPage />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/inventory/transfers/:id"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['stock.transfer.read']}>
              <StockTransferDetailPage />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      {/* Drafts only — the form itself bounces a shipped transfer back to the
          detail page, so the deep link can never edit moved stock. */}
      <Route
        path="/inventory/transfers/:id/edit"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['stock.transfer.write']}>
              <StockTransferFormPage edit />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      {/* No AppLayout: the transfer note is paper, and the shell's chrome would
          print with it. */}
      <Route
        path="/inventory/transfers/:id/print"
        element={
          <RequireAuth>
            <RequirePermission any={['stock.transfer.read']}>
              <StockTransferPrintPage />
            </RequirePermission>
          </RequireAuth>
        }
      />
      {/* ── Manufacturing (toggleable module — the server 403s these routes when
          it is off; RequireModule keeps the web from even trying) ── */}
      <Route
        path="/manufacturing/orders"
        element={
          <RequireAuth><AppLayout>
            <RequireModule module="manufacturing">
              <RequirePermission any={['manufacturing.read']}>
                <ProductionOrdersPage />
              </RequirePermission>
            </RequireModule>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/manufacturing/orders/new"
        element={
          <RequireAuth><AppLayout>
            <RequireModule module="manufacturing">
              <RequirePermission any={['manufacturing.write']}>
                <ProductionOrderFormPage />
              </RequirePermission>
            </RequireModule>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/manufacturing/orders/:id"
        element={
          <RequireAuth><AppLayout>
            <RequireModule module="manufacturing">
              <RequirePermission any={['manufacturing.read']}>
                <ProductionOrderDetailPage />
              </RequirePermission>
            </RequireModule>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/manufacturing/orders/:id/edit"
        element={
          <RequireAuth><AppLayout>
            <RequireModule module="manufacturing">
              <RequirePermission any={['manufacturing.write']}>
                <ProductionOrderFormPage edit />
              </RequirePermission>
            </RequireModule>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/manufacturing/boms"
        element={
          <RequireAuth><AppLayout>
            <RequireModule module="manufacturing">
              <RequirePermission any={['manufacturing.read']}>
                <BomsPage />
              </RequirePermission>
            </RequireModule>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/sales/combos"
        element={
          <RequireAuth><AppLayout>
            <RequireModule module="combos">
              {/* A bundle is an item with a component list, so it rides on the
                  item permissions rather than inventing its own. */}
              <RequirePermission any={['items.read']}>
                <CombosPage />
              </RequirePermission>
            </RequireModule>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/inventory/stocktakes"
        element={
          <RequireAuth><AppLayout>
            <RequireModule module="stocktake">
              <RequirePermission any={['stock.read']}>
                <StocktakesPage />
              </RequirePermission>
            </RequireModule>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/inventory/stocktakes/:id"
        element={
          <RequireAuth><AppLayout>
            <RequireModule module="stocktake">
              <RequirePermission any={['stock.read']}>
                <StocktakeDetailPage />
              </RequirePermission>
            </RequireModule>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/inventory/batches"
        element={
          <RequireAuth><AppLayout>
            <RequireModule module="batches">
              <RequirePermission any={['stock.read']}>
                <BatchesPage />
              </RequirePermission>
            </RequireModule>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/inventory/movements"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['stock.read']}>
              <StockMovementsPage />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/accounting/journals"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['gl.read']}>
                <JournalsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/accounting/transactions"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['gl.read']}>
                <TransactionsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/accounting/vouchers/receipts"
        element={
          <RequireAuth>
            <AppLayout>
              <RequireModule module="vouchers">
                <RequirePermission any={['gl.read']}>
                  <VouchersPage type="receipt" />
                </RequirePermission>
              </RequireModule>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/accounting/vouchers/payments"
        element={
          <RequireAuth>
            <AppLayout>
              <RequireModule module="vouchers">
                <RequirePermission any={['gl.read']}>
                  <VouchersPage type="payment" />
                </RequirePermission>
              </RequireModule>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/accounting/transfers"
        element={
          <RequireAuth>
            <AppLayout>
              <RequireModule module="treasury">
                <RequirePermission any={['gl.read']}>
                  <TreasuryTransfersPage />
                </RequirePermission>
              </RequireModule>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/accounting/exchange-rates"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['exchange_rates.read']}>
                <ExchangeRatesPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/delivery"
        element={
          <RequireAuth>
            <AppLayout>
              <RequireModule module="delivery">
                <RequirePermission any={['delivery.read']}>
                  <DeliveryBoardPage />
                </RequirePermission>
              </RequireModule>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/delivery/mine"
        element={
          <RequireAuth>
            <AppLayout>
              <RequireModule module="delivery">
                <RequirePermission any={['delivery.deliver']}>
                  <MyDeliveriesPage />
                </RequirePermission>
              </RequireModule>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/delivery/cities"
        element={
          <RequireAuth>
            <AppLayout>
              <RequireModule module="delivery">
                <RequirePermission any={['cms.read']}>
                  <DeliveryCitiesPage />
                </RequirePermission>
              </RequireModule>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/delivery/:id"
        element={
          <RequireAuth>
            <AppLayout>
              <RequireModule module="delivery">
                <RequirePermission any={['delivery.read']}>
                  <DeliveryDetailPage />
                </RequirePermission>
              </RequireModule>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/marketing/stories"
        element={
          <RequireAuth>
            <AppLayout>
              <RequireModule module="stories">
                <RequirePermission any={['stories.read']}>
                  <StoriesPage />
                </RequirePermission>
              </RequireModule>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/marketing/highlights"
        element={
          <RequireAuth>
            <AppLayout>
              <RequireModule module="stories">
                <RequirePermission any={['stories.read']}>
                  <HighlightsPage />
                </RequirePermission>
              </RequireModule>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/accounting/journals/new"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['gl.post']}>
              <JournalEntryFormPage />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/accounting/journals/:id/edit"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['gl.post']}>
              <JournalEntryFormPage />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/accounting/journals/:id/print"
        element={
          <RequireAuth>
            <RequirePermission any={['gl.read']}>
              <JournalVoucherPrintPage />
            </RequirePermission>
          </RequireAuth>
        }
      />
      <Route
        path="/accounting/periods"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['periods.read']}>
              <PeriodsPage />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/accounting/trial-balance"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['gl.read']}>
                <TrialBalancePage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/sales/invoices"
        element={
          <RequireAuth>
            <AppLayout>
              {/* فواتير البيع — invoices and orders as two tabs of one page.
                  Both paths are kept: every "view all" link, the command
                  palette and every link already sent to a customer points at
                  one of them, and the page reads the path to pick its tab. */}
              <RequirePermission any={['invoices.read', 'sales_orders.read']}>
                <SalesDocumentsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/sales/orders"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['invoices.read', 'sales_orders.read']}>
                <SalesDocumentsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/sales/returns"
        element={
          <RequireAuth><AppLayout>
            <RequireModule module="returns">
              <RequirePermission any={['invoices.read']}>
                <ReturnsPage />
              </RequirePermission>
            </RequireModule>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/sales/returns/new"
        element={
          <RequireAuth><AppLayout>
            <RequireModule module="returns">
              <RequirePermission any={['invoices.credit']}>
                <ReturnNewPage />
              </RequirePermission>
            </RequireModule>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/sales/returns/:id"
        element={
          <RequireAuth><AppLayout>
            <RequireModule module="returns">
              <RequirePermission any={['invoices.read']}>
                <ReturnDetailPage />
              </RequirePermission>
            </RequireModule>
          </AppLayout></RequireAuth>
        }
      />
      {/* Purchase orders are gone: a purchase is entered as a bill directly, with
          no order to raise and execute first. Old links (bookmarks, a pasted
          /purchasing/orders/:id) land on the bills list rather than a 404. */}
      <Route path="/purchasing/orders/*" element={<Navigate to="/purchasing/bills" replace />} />
      <Route
        path="/purchasing/bills"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['bills.read']}>
                <DocumentListPage
                  ns="documents:bills"
                  endpoint="/bills"
                  statusTone={{ draft: 'neutral', approved: 'info', paid: 'success', cancelled: 'danger' }}
                  newPath="/purchasing/bills/new"
                  detailPath="/purchasing/bills"
                  editable
                  printPath="/purchasing/bills"
                  writePermission="bills.write"
                  postPermission="bills.post"
                />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/payments"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['payments.read']}>
                <DocumentListPage
                  ns="documents:payments"
                  endpoint="/payments"
                  dateField="paymentDate"
                  printPath="/payments"
                  statusTone={{ draft: 'neutral', posted: 'success', voided: 'danger' }}
                  postPermission="payments.post"
                />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/payments/:id/print"
        element={
          <RequireAuth>
            <RequirePermission any={['payments.read']}>
              <PaymentVoucherPrintPage />
            </RequirePermission>
          </RequireAuth>
        }
      />
      <Route
        path="/reports/statistics"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['reports.financial']}>
                <StatisticsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/reports/ai"
        element={
          <RequireAuth>
            <AppLayout>
              <RequireModule module="ai_reports">
                <RequirePermission any={['ai_reports.read']}>
                  <AiReportsPage />
                </RequirePermission>
              </RequireModule>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/reports/ai/:id"
        element={
          <RequireAuth>
            <AppLayout>
              <RequireModule module="ai_reports">
                <RequirePermission any={['ai_reports.read']}>
                  <AiReportViewPage />
                </RequirePermission>
              </RequireModule>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/reports/stock"
        element={
          <RequireAuth><AppLayout>
            {/* stock.read, like the stock page — which already shows cost and
                value to whoever can open it. */}
            <RequirePermission any={['stock.report']}>
              <StockReportPage />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/reports/cashback"
        element={
          <RequireAuth>
            <AppLayout>
              {/* Gated on the module as well as the permission: a shop that does
                  not run cashback should not be offered a report about it. */}
              <RequireModule module="cashback">
                <RequirePermission any={['reports.read']}>
                  <CashbackReportPage />
                </RequirePermission>
              </RequireModule>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/reports/profit"
        element={
          <RequireAuth><AppLayout>
            {/* Its own permission, not `reports.read` — cost is the one figure a
                shop keeps off the screens of people who may read every other report.
                The whole-shop code, not the per-sale `profits.read`. */}
            <RequirePermission any={['profits.report']}>
              <ProfitReportPage />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/reports/profit-and-loss"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['reports.financial']}>
                <PnLPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/reports/balance-sheet"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['reports.financial']}>
                <BalanceSheetPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/reports/ar-aging"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['reports.read']}>
              <AgingPage endpoint="ar-aging" ns="arAging" />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/reports/ap-aging"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['reports.read']}>
              <AgingPage endpoint="ap-aging" ns="apAging" />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/reports/expenses"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['expenses.read']}>
              <ExpensesReportPage />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/sales/orders/new"
        element={
          <RequireAuth><AppLayout>
            {/* NEW only. The `/:id/edit` twin below carries no module gate on
                purpose: switching manual entry off must never strand a document
                someone still has to correct. */}
            <RequireModule module="manual_sales">
              <RequirePermission any={['sales_orders.write']}>
                <DocumentFormPage ns="documents:salesOrders" endpoint="/sales-orders" partySide="customer" hasDueDate={false} listPath="/sales/orders" />
              </RequirePermission>
            </RequireModule>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/sales/invoices/new"
        element={
          <RequireAuth><AppLayout>
            <RequireModule module="manual_sales">
              <RequirePermission any={['invoices.write']}>
                <DocumentFormPage ns="documents:invoices" endpoint="/invoices" partySide="customer" hasDueDate={true} listPath="/sales/invoices" />
              </RequirePermission>
            </RequireModule>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/purchasing/bills/new"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['bills.write']}>
              <DocumentFormPage ns="documents:bills" endpoint="/bills" partySide="vendor" hasDueDate={true} docDateLabelKey="form.purchaseDate" dueDateLabelKey="form.settlementDate" listPath="/purchasing/bills" />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />

      <Route
        path="/sales/orders/:id"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['sales_orders.read']}>
              <DocumentDetailPage
                ns="documents:salesOrders"
                endpoint="/sales-orders"
                listPath="/sales/orders"
                editPath="/sales/orders"
                printPath="/sales/orders"
                writePermission="sales_orders.write"
                whatsappDocType="salesOrder"
                statusTone={{ draft: 'neutral', submitted: 'info', fulfilled: 'success', cancelled: 'danger' }}
              />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/sales/orders/:id/print"
        element={
          <RequireAuth>
            <RequirePermission any={['sales_orders.read']}>
              <SalesOrderPrintPage />
            </RequirePermission>
          </RequireAuth>
        }
      />
      <Route
        path="/pos/sales/:id/print"
        element={
          <RequireAuth>
            <RequirePermission any={['pos.read']}>
              <PosSalePrintPage />
            </RequirePermission>
          </RequireAuth>
        }
      />
      <Route
        path="/sales/orders/:id/edit"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['sales_orders.write']}>
              <DocumentFormPage ns="documents:salesOrders" endpoint="/sales-orders" partySide="customer" hasDueDate={false} listPath="/sales/orders" edit />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/sales/invoices/:id"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['invoices.read']}>
              <DocumentDetailPage
                ns="documents:invoices"
                endpoint="/invoices"
                listPath="/sales/invoices"
                editPath="/sales/invoices"
                printPath="/sales/invoices"
                writePermission="invoices.write"
                whatsappDocType="invoice"
                statusTone={{ draft: 'neutral', issued: 'info', paid: 'success', cancelled: 'danger' }}
                postPermission="invoices.post"
              />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/sales/invoices/:id/print"
        element={
          <RequireAuth>
            <RequirePermission any={['invoices.read']}>
              <InvoicePrintPage />
            </RequirePermission>
          </RequireAuth>
        }
      />
      <Route
        path="/sales/invoices/:id/edit"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['invoices.write']}>
              <DocumentFormPage ns="documents:invoices" endpoint="/invoices" partySide="customer" hasDueDate={true} listPath="/sales/invoices" edit />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      {/* Quotations (toggleable module) */}
      <Route
        path="/quotations"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['quotations.read']}>
              <DocumentListPage
                ns="documents:quotations"
                endpoint="/quotations"
                statusTone={{ draft: 'neutral', sent: 'info', accepted: 'success', rejected: 'danger', expired: 'warning', converted: 'brand' }}
                newPath="/quotations/new"
                detailPath="/quotations"
                editable
                printPath="/quotations"
                writePermission="quotations.write"
              />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/quotations/new"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['quotations.write']}>
              <DocumentFormPage ns="documents:quotations" endpoint="/quotations" partySide="customer" hasDueDate dueDateLabelKey="form.validUntil" listPath="/quotations" />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/quotations/:id"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['quotations.read']}>
              <DocumentDetailPage
                ns="documents:quotations"
                endpoint="/quotations"
                listPath="/quotations"
                editPath="/quotations"
                printPath="/quotations"
                writePermission="quotations.write"
                whatsappDocType="quote"
                quotation
                dueDateLabelKey="detail.validUntil"
                statusTone={{ draft: 'neutral', sent: 'info', accepted: 'success', rejected: 'danger', expired: 'warning', converted: 'brand' }}
              />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/quotations/:id/edit"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['quotations.write']}>
              <DocumentFormPage ns="documents:quotations" endpoint="/quotations" partySide="customer" hasDueDate dueDateLabelKey="form.validUntil" listPath="/quotations" edit />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/quotations/:id/print"
        element={
          <RequireAuth>
            <RequirePermission any={['quotations.read']}>
              <QuotationPrintPage />
            </RequirePermission>
          </RequireAuth>
        }
      />
      <Route
        path="/purchasing/bills/:id"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['bills.read']}>
              <DocumentDetailPage
                ns="documents:bills"
                endpoint="/bills"
                listPath="/purchasing/bills"
                editPath="/purchasing/bills"
                printPath="/purchasing/bills"
                writePermission="bills.write"
                statusTone={{ draft: 'neutral', approved: 'info', paid: 'success', cancelled: 'danger' }}
                postPermission="bills.post"
                dateLabelKey="detail.purchaseDate"
                dueDateLabelKey="detail.settlementDate"
              />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />
      <Route
        path="/purchasing/bills/:id/print"
        element={
          <RequireAuth>
            <RequirePermission any={['bills.read']}>
              <BillPrintPage />
            </RequirePermission>
          </RequireAuth>
        }
      />
      <Route
        path="/purchasing/bills/:id/edit"
        element={
          <RequireAuth><AppLayout>
            <RequirePermission any={['bills.write']}>
              <DocumentFormPage ns="documents:bills" endpoint="/bills" partySide="vendor" hasDueDate={true} docDateLabelKey="form.purchaseDate" dueDateLabelKey="form.settlementDate" listPath="/purchasing/bills" edit />
            </RequirePermission>
          </AppLayout></RequireAuth>
        }
      />

      <Route
        path="/hr/employees"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['hr.employees.read']}>
                <EmployeesPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/hr/organization"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['hr.org.read']}>
                <OrganizationPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/hr/payroll"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['hr.payroll.read']}>
                <PayrollRunsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/hr/attendance"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['hr.time.read', 'hr.time.approve', 'hr.self.time.entry', 'hr.self.read', 'hr.admin']}>
                <AttendancePage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      {/* The kiosk: no sidebar, a login that may hold nothing but hr.time.kiosk. */}
      <Route
        path="/hr/attendance/kiosk"
        element={
          <RequireAuth>
            <AppLayout kiosk>
              <RequirePermission any={['hr.time.kiosk', 'hr.time.approve']}>
                <AttendanceKioskPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/hr/leave"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['hr.leave.read', 'hr.self.read']}>
                <LeaveRequestsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/crm/accounts"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['crm.accounts.read']}>
                <CrmAccountsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/crm/contacts"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['crm.contacts.read']}>
                <ContactsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/crm/leads"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['crm.leads.read']}>
                <LeadsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/crm/opportunities"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['crm.opportunities.read']}>
                <OpportunitiesPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/crm/activities"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['crm.activities.read']}>
                <ActivitiesPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/expenses"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['expenses.read']}>
                <ExpensesPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/installments/plans"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['installments.read']}>
                <InstallmentPlansPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/installments/reports"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['installments.read']}>
                <InstallmentReportsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/pos/register"
        element={
          <RequireAuth>
            <AppLayout kiosk>
              <RequirePermission any={['pos.sell', 'pos.read']}>
                <PosRegisterPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      {/* Customer-facing second screen — standalone (no app chrome), opened on a
          second monitor from the register; gated by the customer_display module. */}
      <Route
        path="/pos/display"
        element={
          <RequireAuth>
            <RequirePermission any={['pos.sell', 'pos.read']}>
              <RequireModule module="customer_display">
                <CustomerDisplayPage />
              </RequireModule>
            </RequirePermission>
          </RequireAuth>
        }
      />
      <Route
        path="/pos/sales"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['pos.read']}>
                <PosSalesPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/pos/shifts"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['pos.read']}>
                <TerminalShiftsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/pos/terminals"
        element={
          <RequireAuth>
            <AppLayout>
              <RequirePermission any={['pos.terminal.admin', 'pos.read']}>
                <PosTerminalsPage />
              </RequirePermission>
            </AppLayout>
          </RequireAuth>
        }
      />

      {/* Platform admin shell — disjoint from the tenant routes. */}
      <Route path="/platform/login" element={<PlatformLoginPage />} />
      <Route
        path="/platform/tenants"
        element={
          <RequirePlatformAuth>
            <PlatformLayout>
              <PlatformTenantsPage />
            </PlatformLayout>
          </RequirePlatformAuth>
        }
      />
      <Route
        path="/platform/tenants/new"
        element={
          <RequirePlatformAuth>
            <PlatformLayout>
              <PlatformTenantCreatePage />
            </PlatformLayout>
          </RequirePlatformAuth>
        }
      />
      <Route
        path="/platform/tenants/:id"
        element={
          <RequirePlatformAuth>
            <PlatformLayout>
              <PlatformTenantDetailPage />
            </PlatformLayout>
          </RequirePlatformAuth>
        }
      />
      <Route
        path="/platform/payments"
        element={
          <RequirePlatformAuth>
            <PlatformLayout>
              <PlatformPaymentsPage />
            </PlatformLayout>
          </RequirePlatformAuth>
        }
      />
      <Route
        path="/platform/admins"
        element={
          <RequirePlatformAuth>
            <PlatformLayout>
              <PlatformAdminsPage />
            </PlatformLayout>
          </RequirePlatformAuth>
        }
      />
      <Route
        path="/platform/currencies"
        element={
          <RequirePlatformAuth>
            <PlatformLayout>
              <PlatformCurrenciesPage />
            </PlatformLayout>
          </RequirePlatformAuth>
        }
      />
      <Route
        path="/platform/terminal"
        element={
          <RequirePlatformAuth>
            <PlatformLayout>
              <PlatformTerminalPage />
            </PlatformLayout>
          </RequirePlatformAuth>
        }
      />
      <Route
        path="/platform/whatsapp"
        element={
          <RequirePlatformAuth>
            <PlatformLayout>
              <PlatformWhatsAppPage />
            </PlatformLayout>
          </RequirePlatformAuth>
        }
      />
      <Route
        path="/platform/otp-service"
        element={
          <RequirePlatformAuth>
            <PlatformLayout>
              <PlatformOtpServicePage />
            </PlatformLayout>
          </RequirePlatformAuth>
        }
      />
      {/* Register the static docs + payment-claims paths BEFORE the :id catch-all. */}
      <Route
        path="/platform/otp-service/docs"
        element={
          <RequirePlatformAuth>
            <PlatformLayout>
              <PlatformOtpDocsPage />
            </PlatformLayout>
          </RequirePlatformAuth>
        }
      />
      <Route
        path="/platform/otp-service/payment-claims"
        element={
          <RequirePlatformAuth>
            <PlatformLayout>
              <PlatformOtpPaymentClaimsPage />
            </PlatformLayout>
          </RequirePlatformAuth>
        }
      />
      <Route
        path="/platform/otp-service/:id"
        element={
          <RequirePlatformAuth>
            <PlatformLayout>
              <PlatformOtpClientDetailPage />
            </PlatformLayout>
          </RequirePlatformAuth>
        }
      />
      <Route
        path="/platform/change-password"
        element={
          <RequirePlatformAuth>
            <PlatformLayout>
              <PlatformChangePasswordPage />
            </PlatformLayout>
          </RequirePlatformAuth>
        }
      />
      <Route
        path="/platform/storage"
        element={
          <RequirePlatformAuth>
            <PlatformLayout>
              <PlatformStoragePage />
            </PlatformLayout>
          </RequirePlatformAuth>
        }
      />
      <Route
        path="/platform/audit"
        element={
          <RequirePlatformAuth>
            <PlatformLayout>
              <PlatformAuditPage />
            </PlatformLayout>
          </RequirePlatformAuth>
        }
      />

      {/* Customer portal — disjoint from the tenant + platform routes. */}
      <Route path="/portal/login" element={<PortalLoginPage />} />
      <Route
        path="/portal/dashboard"
        element={
          <RequireCustomerAuth>
            <CustomerPortalLayout>
              <PortalDashboardPage />
            </CustomerPortalLayout>
          </RequireCustomerAuth>
        }
      />
      <Route
        path="/portal/orders"
        element={
          <RequireCustomerAuth>
            <CustomerPortalLayout>
              <PortalOrdersPage />
            </CustomerPortalLayout>
          </RequireCustomerAuth>
        }
      />
      <Route
        path="/portal/orders/:id"
        element={
          <RequireCustomerAuth>
            <CustomerPortalLayout>
              <PortalOrderDetailPage />
            </CustomerPortalLayout>
          </RequireCustomerAuth>
        }
      />
      {/* Invoice + payment LISTS live inside the statement page's tabs now;
          the old routes redirect so bookmarks and sent links keep working. */}
      <Route path="/portal/invoices" element={<Navigate to="/portal/statement?tab=invoices" replace />} />
      <Route
        path="/portal/invoices/:id"
        element={
          <RequireCustomerAuth>
            <CustomerPortalLayout>
              <PortalInvoiceDetailPage />
            </CustomerPortalLayout>
          </RequireCustomerAuth>
        }
      />
      <Route path="/portal/payments" element={<Navigate to="/portal/statement?tab=payments" replace />} />
      <Route
        path="/portal/payments/:id"
        element={
          <RequireCustomerAuth>
            <CustomerPortalLayout>
              <PortalPaymentDetailPage />
            </CustomerPortalLayout>
          </RequireCustomerAuth>
        }
      />
      <Route
        path="/portal/statement"
        element={
          <RequireCustomerAuth>
            <CustomerPortalLayout>
              <PortalStatementPage />
            </CustomerPortalLayout>
          </RequireCustomerAuth>
        }
      />
      <Route
        path="/portal/cashback"
        element={
          <RequireCustomerAuth>
            <CustomerPortalLayout>
              <PortalCashbackPage />
            </CustomerPortalLayout>
          </RequireCustomerAuth>
        }
      />
      <Route
        path="/portal/notifications"
        element={
          <RequireCustomerAuth>
            <CustomerPortalLayout>
              <PortalNotificationsPage />
            </CustomerPortalLayout>
          </RequireCustomerAuth>
        }
      />
      <Route
        path="/portal/profile"
        element={
          <RequireCustomerAuth>
            <CustomerPortalLayout>
              <PortalProfilePage />
            </CustomerPortalLayout>
          </RequireCustomerAuth>
        }
      />

      {/* Public read-only invoice — UNAUTHENTICATED; resolved from a signed token. */}
      <Route path="/i/:token" element={<PublicInvoicePage />} />
      {/* Public, no-auth order view — the target of the Telegram order alert and
          of the QR printed on a sales order. Anyone with the link, no session. */}
      <Route path="/o/:token" element={<PublicOrderPage />} />
      {/* Public read-only PAPER — the same A4/80mm renderer staff see, no login.
          Its own docType namespace, so an old /o/ or /i/ token can never open it. */}
      <Route path="/d/:token" element={<PublicDocumentPage />} />

      {/* Public storefront — UNAUTHENTICATED; the layout resolves the tenant
          from :slug and 404s if the store isn't published. */}
      <Route
        path="/s/:slug"
        element={
          <StorefrontLayout>
            <StorefrontHomePage />
          </StorefrontLayout>
        }
      />
      <Route
        path="/s/:slug/p/:pageSlug"
        element={
          <StorefrontLayout>
            <StorefrontPage />
          </StorefrontLayout>
        }
      />
      <Route
        path="/s/:slug/shop"
        element={
          <StorefrontLayout>
            <StorefrontCatalogPage />
          </StorefrontLayout>
        }
      />
      <Route
        path="/s/:slug/categories"
        element={
          <StorefrontLayout>
            <StorefrontCategoriesPage />
          </StorefrontLayout>
        }
      />
      <Route
        path="/s/:slug/category/:catSlug"
        element={
          <StorefrontLayout>
            <StorefrontCategoryPage />
          </StorefrontLayout>
        }
      />
      <Route
        path="/s/:slug/brands"
        element={
          <StorefrontLayout>
            <StorefrontBrandsPage />
          </StorefrontLayout>
        }
      />
      <Route
        path="/s/:slug/brand/:brandId"
        element={
          <StorefrontLayout>
            <StorefrontBrandPage />
          </StorefrontLayout>
        }
      />
      <Route
        path="/s/:slug/product/:id"
        element={
          <StorefrontLayout>
            <StorefrontProductPage />
          </StorefrontLayout>
        }
      />
      <Route
        path="/s/:slug/cart"
        element={
          <StorefrontLayout>
            <StorefrontCartPage />
          </StorefrontLayout>
        }
      />
      <Route
        path="/s/:slug/wishlist"
        element={
          <StorefrontLayout>
            <StorefrontWishlistPage />
          </StorefrontLayout>
        }
      />
      <Route
        path="/s/:slug/login"
        element={
          <StorefrontLayout>
            <StorefrontLoginPage />
          </StorefrontLayout>
        }
      />
      <Route
        path="/s/:slug/checkout"
        element={
          <StorefrontLayout>
            <StorefrontCheckoutPage />
          </StorefrontLayout>
        }
      />
      <Route
        path="/s/:slug/order/:number"
        element={
          <StorefrontLayout>
            <StorefrontOrderPage />
          </StorefrontLayout>
        }
      />
      {/* Unknown store path → resolve WITHIN the storefront tree. Keeps the
          custom-domain gate from bouncing it to the app's global catch-all and
          back under /s/:slug forever. */}
      <Route
        path="/s/:slug/*"
        element={
          <StorefrontLayout>
            <StorefrontNotFoundPage />
          </StorefrontLayout>
        }
      />

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
